import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaSave, FaAngleLeft } from 'react-icons/fa';

import { API } from 'aws-amplify';
import { useToasts } from 'react-toast-notifications';

const ProfileDetail = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { addToast } = useToasts();
  const [selProfile, setSelProfile] = useState({});
  const [profName, setProfName] = useState('');

  const params = {
    headers: {
      'x-api-key': process.env.REACT_APP_API_KEY,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  // Fetch user details and permissions from the API
  useEffect(() => {
    const fetchPermissions = async () => {
      setIsLoading(true);  // Start loading indicator
      try {
        // Fetch global permissions
        const global_perm = await API.get('global_custom_permission_list', '/', params);
        let globalPermissions = global_perm[0].customProfile || {};

        // Ensure all global permissions are unchecked
        globalPermissions = Object.keys(globalPermissions).reduce((acc, category) => {
          acc[category] = Object.keys(globalPermissions[category]).reduce((permAcc, permission) => {
            permAcc[permission] = {
              ...globalPermissions[category][permission],
              checked: false  // Set the `checked` state to false
            };
            return permAcc;
          }, {});
          return acc;
        }, {});

        // Fetch profile-specific permissions
        const response = await API.get('profile_det', '/' + props.match.params.id, params);
        const { profile_name, ...profilePermissions } = response.customProfile || {};

        // Merge global permissions with profile-specific ones
        const mergedPermissions = { ...globalPermissions }; // Start with global permissions
        Object.keys(profilePermissions).forEach((category) => {
          if (!mergedPermissions[category]) {
            // If category doesn't exist in global, add it
            mergedPermissions[category] = profilePermissions[category];
          } else {
            // Merge each permission under the category
            Object.keys(profilePermissions[category]).forEach((permission) => {
              mergedPermissions[category][permission] = profilePermissions[category][permission];
            });
          }
        });
        // Set merged permissions and profile name
        setSelProfile(mergedPermissions);
        setProfName(profile_name || '');
      } catch (error) {
        console.error('Error fetching permissions:', error);
        addToast('Error fetching profile', { appearance: 'error' });
      } finally {
        setIsLoading(false);  // Stop loading indicator
      }
    };

    fetchPermissions();
  }, [props.match.params.id]);

  // Handle checkbox change
  const handleCheckboxChange = (category, permission) => {
    setSelProfile((prevProfile) => ({
      ...prevProfile,
      [category]: {
        ...prevProfile[category],
        [permission]: {
          ...prevProfile[category][permission],
          checked: !prevProfile[category][permission].checked, // Toggle checked state
        },
      },
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // setIsLoading(true);

    selProfile.profile_name = profName

    try {
      await API.post('upd_custom_permissions', '/' + props.match.params.id, {
        body: {
          customProfile: selProfile
        },
        headers: {
          'x-api-key': process.env.REACT_APP_API_KEY
        }
      });

      props.history.push('/custom_profile/');
      addToast('Saved successfully', { appearance: 'success' });
    } catch (error) {
      console.error('Error saving profile:', error);
      //   addToast('Error saving profile', { appearance: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return !isLoading ? (
    <div className="DeviceList">
      <div className="col-md-12">
        <form onSubmit={handleSubmit}>
        
          <div className="row header pb-1">
            <div className="col-md-6">Custom Profile</div>
            <div className="col-md-6 text-right d-flex justify-content-end">
              <Button variant="secondary" className="mr-1 text-nowrap" onClick={() => { props.history.goBack() }}>
                Back &nbsp;
                <FaAngleLeft />
              </Button>
              <Button variant="success" className="text-nowrap" type="submit">
                Save &nbsp;
                <FaSave />
              </Button>
            </div>
          </div>

          <div className="row div-content">
            <div className="pl-5">
              <Form.Group controlId="profile">
                <Form.Group controlId="name">
                  <Form.Label>Profile Name</Form.Label>
                  <Form.Control
                    autoFocus
                    type="input"
                    value={profName}
                    onChange={(e) => setProfName(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Form.Group>
            </div>
            <div className="col-md-12">
              <div className="p-3">
                <div className="col-md-12">
                  <div className="row px-3">
                    <div className="col-md-12">
                      <div className="row">
                        {Object.keys(selProfile).map((category, i) => (
                          <div key={`category-${i}`} className="col-md-3">
                            <h4>{category}</h4>
                            <div>
                              {Object.keys(selProfile[category]).map((permission, j) => (
                                <div key={`permission-${category}-${j}`}>
                                  <Form.Check
                                    type="checkbox"
                                    id={permission}
                                    label={selProfile[category][permission].label}
                                    checked={selProfile[category][permission].checked}
                                    onChange={() => handleCheckboxChange(category, permission)}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  ) : (
    <div>Loading...</div>
  );
};

export default ProfileDetail;
